import styled from 'styled-components'
import { useNavigate, useSearchParams, Link } from 'react-router-dom'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import http from '../../components/http/http'
import { getUrl } from '../../components/getSubjectId'
import ContainerContent from '../../components/ContainerContent'
import { BackBtn } from '../../components/shared/NavigationButtons';
import './styles/ThemeInfo.css'

const Background = styled.div``

const Block = styled.div`
  width: 100%;
  z-index: 1;
`

const Box = styled.div`
  margin: 20px 0px;

  > div {
    margin-bottom: 20px;
  }
`

const SubjectNameGender = () => {
  const { t } = useTranslation()
  return <span className={'linkSpan afade'} data-fade>{t('goBack')}</span>
}

const Main = () => {
  const { t, i18n } = useTranslation()
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const [theme, setTheme] = useState<any>(null)
  const [loading, setLoading] = useState(true)
  const [isMobile, setIsMobile] = useState(false)

  const themeId = searchParams.get('theme')
  const gender = searchParams.get('gender')
  const race = searchParams.get('race')
  const age = searchParams.get('age')

  const getFormUrl = () => {
    const url = `/form?theme=${themeId}&gender=${gender || ''}&race=${race || ''}&age=${age || ''}`;
    console.log('Form URL:', url);
    return url;
  }

  const getThemeName = (theme: any) => {
    if (!theme?.name) return theme?._id || ''

    if (typeof theme.name === 'string') {
      return theme.name
    }

    if (typeof theme.name === 'object' && theme.name[i18n.language]) {
      return theme.name[i18n.language]
    }

    return theme.name.en || theme.name.de || theme._id || ''
  }

  useEffect(() => {
    const checkMobile = () => setIsMobile(window.matchMedia('(max-width: 700px)').matches);
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  useEffect(() => {
    document.body.classList.add('max-width-1200');
    return () => {
      document.body.classList.remove('max-width-1200');
    };
  }, []);

  useEffect(() => {
    console.log('theme', theme)
  }, [])


  useEffect(() => {
    if (!themeId) {
      navigate('/home')
      return
    }

    const fetchTheme = async () => {
      try {
        console.log('Fetching all subjects to find theme with ID:', themeId)
        const response = await http.get('/api/core/theme/subject?per_page=1001')
        console.log('All subjects response:', response)

        // Ищем тему с нужным ID
        const foundTheme = response.find((subject: any) => subject._id == themeId)
        console.log('Found theme:', foundTheme)

        if (foundTheme) {
          setTheme(foundTheme)
        } else {
          console.error('Theme not found with ID:', themeId)
          setTheme(null)
        }
      } catch (error) {
        console.error('Error fetching themes:', error)
        setTheme(null)
      } finally {
        setLoading(false)
      }
    }

    fetchTheme()
  }, [themeId, navigate])

  if (loading) {
    return (
      <ContainerContent>
        <Block>
          <div className="loading-container">
            <div className="loading-spinner">
              <div className="spinner-ring"></div>
              <div className="spinner-ring"></div>
              <div className="spinner-ring"></div>
            </div>
            <div className="loading-text">Loading theme information...</div>
          </div>
        </Block>
      </ContainerContent>
    )
  }

  //   if (!theme) {
  //     return (
  //       <ContainerContent>
  //         <Block>
  //           <div>
  //             <h2>Theme not found</h2>
  //             <p>Theme ID: {themeId}</p>
  //             <Link to="/home" className="btn btn1">Back to Themes</Link>
  //           </div>
  //         </Block>
  //       </ContainerContent>
  //     )
  //   }


  return (
    <ContainerContent>
      <div className={'paddDesc'}>
        <Block data-animch data-rel>
          <div className={'wrapTitleNav'}>
            <Link to={getUrl('home')} className={'mytitle'} style={{ width: 'auto' }}>
              <BackBtn></BackBtn>
              {!isMobile && <SubjectNameGender />}
            </Link>
            <div className="brnsNextWrap">
              <div className="text-right">
                <Link to={getFormUrl()} className={'btn btn1'}>{t('skip')}</Link>
                <Link to={getFormUrl()} className={'btn btn2'} style={{ marginLeft: '12px' }}>{t('next')}</Link>
              </div>
            </div>
          </div>
          <Block>
            <div className="theme-info-container">
              <div className="theme-header">
                <h1 className="theme-title">{getThemeName(theme)}</h1>
              </div>

              <div className="theme-description">
                {i18n.exists('themeInfo.basic-checkup.description.intro') && (
                  <p>
                    {t('themeInfo.basic-checkup.description.intro')}
                  </p>
                )}
                {i18n.exists('themeInfo.basic-checkup.description.basicCheckup') && (
                  <p>
                    {t('themeInfo.basic-checkup.description.basicCheckup')}
                  </p>
                )}
                {i18n.exists('themeInfo.basic-checkup.description.weAnalyse') && (
                  <p>
                    {t('themeInfo.basic-checkup.description.weAnalyse')}
                  </p>
                )}
                {(i18n.exists('themeInfo.basic-checkup.description.cbc') ||
                  i18n.exists('themeInfo.basic-checkup.description.lipidProfile') ||
                  i18n.exists('themeInfo.basic-checkup.description.glucoseLevels')) && (
                    <ul>
                      {i18n.exists('themeInfo.basic-checkup.description.cbc') && (
                        <li>{t('themeInfo.basic-checkup.description.cbc')}</li>
                      )}
                      {i18n.exists('themeInfo.basic-checkup.description.lipidProfile') && (
                        <li>{t('themeInfo.basic-checkup.description.lipidProfile')}</li>
                      )}
                      {i18n.exists('themeInfo.basic-checkup.description.glucoseLevels') && (
                        <li>{t('themeInfo.basic-checkup.description.glucoseLevels')}</li>
                      )}
                    </ul>
                  )}
                {i18n.exists('themeInfo.basic-checkup.description.markers') && (
                  <p>
                    {t('themeInfo.basic-checkup.description.markers')}
                  </p>
                )}
              </div>


              <div className="next-steps-section">
                <h2>{t('themeInfo.whatToDoNext')}</h2>
                <div className="steps-container">
                  <div className="step-block">
                    <div className="step-icon">
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none" /><path d="M9 6l11 0" /><path d="M9 12l11 0" /><path d="M9 18l11 0" /><path d="M5 6l0 .01" /><path d="M5 12l0 .01" /><path d="M5 18l0 .01" /></svg>
                    </div>
                    <div className="step-number">{t('themeInfo.step1')}</div>
                    <div className="step-title">{t('themeInfo.step1Title')}</div>
                    <div className="step-description">
                      {t('themeInfo.step1Description')}
                    </div>
                    <div className="step-action">
                      <a
                        href={(i18n.language || '').startsWith('de')
                          ? '/pdfs/List Blood Biomarkers for Basick Checkup_V4_DE.pdf'
                          : '/pdfs/List Blood Biomarkers for Basick Checkup_V4_EN.pdf'}
                        download
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {t('themeInfo.download')}
                      </a>
                    </div>
                  </div>

                  <div className="step-block">
                    <div className="step-icon">
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none" /><path d="M4 7a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2v-12z" /><path d="M16 3v4" /><path d="M8 3v4" /><path d="M4 11h16" /><path d="M11 15h1" /><path d="M12 15v3" /></svg>
                    </div>
                    <div className="step-number">{t('themeInfo.step2')}</div>
                    <div className="step-title">{t('themeInfo.step2Title')}</div>
                    <div className="step-description">
                      {t('themeInfo.step2Description')}
                    </div>
                    <div className="step-action">
                      <Link
                        to={`/theme-info/step2?theme=${themeId}&gender=${gender || ''}&race=${race || ''}&age=${age || ''}`}
                      >
                        {t('themeInfo.printOut')}
                      </Link>
                    </div>
                  </div>

                  <div className="step-block">
                    <div className="step-icon">
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none" /><path d="M4 17v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2 -2v-2" /><path d="M7 11l5 5l5 -5" /><path d="M12 4l0 12" /></svg>
                    </div>
                    <div className="step-number">{t('themeInfo.step3')}</div>
                    <div className="step-title">{t('themeInfo.step3Title')}</div>
                    <div className="step-description">
                      {t('themeInfo.step3Description')}
                    </div>
                  </div>

                  <div className="step-block">
                    <div className="step-icon">
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none" /><path d="M7 3m0 2.667a2.667 2.667 0 0 1 2.667 -2.667h8.666a2.667 2.667 0 0 1 2.667 2.667v8.666a2.667 2.667 0 0 1 -2.667 2.667h-8.666a2.667 2.667 0 0 1 -2.667 -2.667z" /><path d="M4.012 7.26a2.005 2.005 0 0 0 -1.012 1.737v10c0 1.1 .9 2 2 2h10c.75 0 1.158 -.385 1.5 -1" /><path d="M11 10h6" /><path d="M14 7v6" /></svg>
                    </div>
                    <div className="step-number">{t('themeInfo.step4')}</div>
                    <div className="step-title">{t('themeInfo.step4Title')}</div>
                    <div className="step-description">
                      {t('themeInfo.step4Description')}
                    </div>
                  </div>

                  <div className="step-block">
                    <div className="step-icon">
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none" /><path d="M9 5h-2a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-12a2 2 0 0 0 -2 -2h-2" /><path d="M9 3m0 2a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v0a2 2 0 0 1 -2 2h-2a2 2 0 0 1 -2 -2z" /><path d="M9 17v-4" /><path d="M12 17v-1" /><path d="M15 17v-2" /><path d="M12 17v-1" /></svg>
                    </div>
                    <div className="step-number">{t('themeInfo.step5')}</div>
                    <div className="step-title">{t('themeInfo.step5Title')}</div>
                    <div className="step-description">
                      {t('themeInfo.step5Description')}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Block>
          <div className="did-you-know">
            <div className="did-you-know-title">{t('themeInfo.didYouKnow.title')}</div>
            <div className="did-you-know-text">
              {t('themeInfo.didYouKnow.text')}
            </div>
          </div>
          <div className="help-text">
            {t('themeInfo.needHelp')} <a href="mailto:info@smrtlife.ch">{t('themeInfo.contactUs')}</a>! {t('themeInfo.supportTeam')}
          </div>
        </Block>
      </div>
    </ContainerContent>
  )
}

export default Main
